import React from "react";
import { Toast } from "react-bootstrap";
import "./CustomToast.scss";
import DoneIcon from "components/icons/DoneIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

interface CustomToastProps {
  show: boolean;
  onClose: () => void;
  message: string;
  width?: string; // Add width property
  /**
   * Success flag to load different icons
   */
  success?: boolean;
}

const CustomToast: React.FC<CustomToastProps> = ({
  show,
  onClose,
  message,
  width = "330px", // Default width
  success = true,
}) => {
  return (
    <Toast
      show={show}
      onClose={onClose}
      delay={3000}
      autohide={true}
      className="custom-toast"
      style={{ width }} // Apply width as inline style
    >
      <div className="custom-toast-content">
        {success ?
          <div className="check-icon">
            <DoneIcon size={30} color="#997404" />
          </div>
          :
          <div className="check-icon">
            <FontAwesomeIcon className="xmark-icon" icon={faXmark}/>
          </div>
        }
        <div className="toast-message">{message}</div>
      </div>
    </Toast>
  );
};

export default CustomToast;
